// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AnalyticsOrganisationItemPagingResultModel from '../../model/analytics-organisation-item-paging-result-model';
import AnalyticsOrganisationItemPagingResultDTO from '../dto/analytics-organisation-item-paging-result-dto';
import dtoSchema from '../schemas/analytics-organisation-item-paging-result-schema';
import AnalyticsOrganisationItemModel from '../../model/analytics-organisation-item-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class AnalyticsOrganisationItemPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AnalyticsOrganisationItemPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => AnalyticsOrganisationItemModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: AnalyticsOrganisationItemModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<AnalyticsOrganisationItemPagingResultDTO>): AnalyticsOrganisationItemPagingResultModel;
  static toModel(dto: DeepPartial<AnalyticsOrganisationItemPagingResultDTO> | undefined | null): AnalyticsOrganisationItemPagingResultModel | undefined;
  static toModel(dto: DeepPartial<AnalyticsOrganisationItemPagingResultDTO> | undefined | null): AnalyticsOrganisationItemPagingResultModel | undefined {
    return dto ? new AnalyticsOrganisationItemPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AnalyticsOrganisationItemPagingResultModel> | AnalyticsOrganisationItemPagingResultModel): AnalyticsOrganisationItemPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as AnalyticsOrganisationItemPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AnalyticsOrganisationItemPagingResultModel, can not map to AnalyticsOrganisationItemPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
